import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import { Box, Button, Collapse, Flex, Group, Stack, Text } from '@mantine/core';

import { getDispatchDisplayData } from 'util/dispatch';
import { DispatchType } from 'store/dispatch/types';

import { DispatchActions } from '../Actions/DispatchActions';

type DispatchMapPopupPropsType = {
  dispatchPlan: DispatchType;
  refreshPage: VoidFunction;
};

export const DispatchMapPopup = ({ dispatchPlan, refreshPage }: DispatchMapPopupPropsType) => {
  const { t, i18n } = useTranslation();
  const [opened, setOpened] = useState(false);

  const chevronDisplay = () => {
    return opened ? <FiChevronUp /> : <FiChevronDown />;
  };

  const {
    agency,
    acres,
    account,
    daysReady,
    field,
    pro,
    sampler,
    scan,
    status,
    tillMapper,
    updated,
  } = getDispatchDisplayData(dispatchPlan, t, i18n.language);
  const dataMappings = {
    agency,
    account,
    field,
    acres,
    status,
    sampler,
    scan,
    pro,
    tillMapper,
    updated,
    daysReady,
  };

  return (
    <Stack gap="sm">
      <Stack gap="0">
        {Object.entries(dataMappings).map(([label, data]) => (
          <Group key={label} justify="space-between" wrap="nowrap" align="flex-start">
            <Text fz="xs" fw="bold">
              {t(label)}:{' '}
            </Text>
            <Text fz="xs" ta="right">
              {data}
            </Text>
          </Group>
        ))}
      </Stack>
      <Flex justify="space-between" direction="row-reverse">
        <DispatchActions
          dispatchPlan={dispatchPlan}
          onSubmit={refreshPage}
          buttonSize="compact-xs"
          buttonStyles={{ label: { fontSize: `var(--mantine-font-size-xs)` } }}
          menuPosition="right-end"
          menuWidth="150"
          menuStyles={{
            itemLabel: { padding: 0, margin: 0, fontSize: `var(--mantine-font-size-xs)` },
            item: { padding: '0.1rem' },
          }}
        />
        {Boolean(dispatchPlan.alerts.length) && (
          <Box>
            <Button
              size="compact-xs"
              onClick={() => setOpened((o) => !o)}
              rightSection={chevronDisplay()}
            >
              <Text fz="xs" fw="bold">
                {t('alerts')}
              </Text>
            </Button>
          </Box>
        )}
      </Flex>
      <Collapse in={opened}>
        <Stack gap="0" ta="left" ml="xs">
          {dispatchPlan.alerts.map((alert) => (
            <Text key={alert.id} fz="xs">{`- ${t(alert.name)}`}</Text>
          ))}
        </Stack>
      </Collapse>
    </Stack>
  );
};
